import './styles';
import Providers from './providers';
import { Options, SupportedPlugins } from './providers/providers.types';

export default SocialEmbeded;

SocialEmbeded.instances = [];

SocialEmbeded.renderAll = (name: SupportedPlugins) => {
  SocialEmbeded.instances.forEach(instance => instance.render(name));
};

function SocialEmbeded(
  options: Options,
  consentHandler = getDefaultPrivacyProvider(),
  providers?: [SupportedPlugins],
  rootElement?: String
  ) {
  let _providers = Providers(consentHandler, rootElement);
  let providersList = _providers.list;
  let initialized = false;

  const defaultConfig: Options = setDefaultConfig({
    callToAction: 'Open Social Content',
    privacyNotes: 'Some privacy note...'
  });

  const currentConfig = { ...defaultConfig };
  configure(options, providers);

  const _this = Object.freeze({
    render,
    configure,
    run
  });

  SocialEmbeded.instances.push(_this);

  return _this;

  function configure(options: Options, onlyList = _providers.list) {
    if (
      Array.isArray(onlyList) &&
      onlyList.length &&
      _providers.list.some(provider => onlyList.includes(provider))
      ) {
      providersList = onlyList;
    }

    providersList.forEach((config) => {
      const option = options[config];

      if (typeof option === 'object') {
        Object.assign(currentConfig[config], option);
      }
    });

    if (initialized) {
      process();
    }

    return _this;
  }

  function run() {
    if (initialized) return;
    initialized = true;

    // In case DOMContentLoaded was already fired, the document readyState will be one of "complete" or "interactive" or (nonstandard) "loaded".
    if (/complete|interactive|loaded/.test(document.readyState)) {
      process();
    } else {
      document.addEventListener('DOMContentLoaded', process, false);
    }
  }

  function process() {
    providersList.forEach((provider) => {
      _providers.process(provider, currentConfig[provider]);
    });
  }

  function render(name: SupportedPlugins) {
    _providers.process(name, currentConfig[name]);
  }

  function setDefaultConfig(options) {
    const cfg = _providers.list.reduce((config, provider) => ({
      [provider]: {
        ...{ autoLoad: _providers.consents.hasConsent(provider) } ,
        ...options
      },
      ...config
    }), {}) as any;

    cfg.tagboard = {
      autoLoad: !!(cfg.facebook.autoLoad && cfg.twitter.autoLoad && cfg.instagram.autoLoad),
      ...options
    };

    return cfg;
  }
}

function getDefaultPrivacyProvider() {
  const usercentrics = window['usercentrics'];

  if (usercentrics && usercentrics['settingsId']) {
    return { name: 'usercentrics', handler: window['usercentrics'] };
  }

  return {};
}
